import qs from 'querystring';

/**
 * Fetches incentives data from payment services using the provided URL and optional additional parameters.
 *
 * @param {Object} params - The parameters for fetching incentives
 * @param {Object} params.incentivesFetcher - Object containing `fetch` method that hits our incentives endpoint
 * @param {string} params.incentivesUrl - URL string for fetching incentives data
 * @param {Object} [params.incentivesParams] - Optional additional parameters to append to the URL
 * @returns {Promise<Array>} Returns an array of incentive details. Returns [{hasError: true}] if there's an error
 *                          or if required parameters are missing
 */
const getIncentives = async _ref => {
  let {
    incentivesFetcher,
    incentivesUrl,
    incentivesParams = null
  } = _ref;
  if (!!incentivesFetcher && incentivesUrl) {
    try {
      const incentives = await incentivesFetcher.fetch(
      // only append params if they exist and are not empty
      incentivesUrl + (incentivesParams && Object.keys(incentivesParams).length > 0 ? `&${qs.stringify(incentivesParams)}` : ''));
      return incentives?.incentiveDetail?.length ? incentives.incentiveDetail : [{
        hasError: true
      }];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error({
        error
      });
      return [{
        hasError: true
      }];
    }
  }
  return [{
    hasError: true
  }];
};
export { getIncentives as default };
